import { DocsData } from "../templates/docs";

export const formatPage = (data: DocsData) => {
  if (data && data.asciidoc) {
    const post = data.asciidoc;
    const formatPage = {
      title: post.title,
      body: post.fields.html,
    };
    return formatPage;
  }
  const errorPage = {
    // TODO: fix title for Redirect page
    title: "Error",
    body: "An Error Occurred!",
  };
  return errorPage;
};
